import React, { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import _get from 'lodash/get';

// atc-ui
import { useFeatures } from '@atc/features';

import {
    RadioGroup,
    Section,
    SeeMore,
} from 'reaxl';
import {
    OwnerAddress,
    OwnerDistance,
} from 'reaxl-molecules';
import { KBBDealerRatings } from 'reaxl-ratings-reviews';

import {
    ownersDuck,
    preorderOwnersDuck,
    queryDuck,
} from '@/ducks';

import {
    bapActiveOwnerDuck,
} from '@/ducks/bap';

const renderOwnerLabel = (dealer, isDealerRatingDisabled) => (
    <div className="padding-bottom-2">
        <div className="text-bold">{dealer.name}</div>
        {!isDealerRatingDisabled && <div><KBBDealerRatings owner={dealer} /></div>}
        <div><OwnerAddress location={dealer.location} /></div>
        <div>
            <OwnerDistance
                owner={dealer}
                showIcon={false}
                uiContext="owner"
            />
        </div>
    </div>
);

function BuildAndPriceDealerContainer() {
    const dispatch = useDispatch();
    const activeOwnerId = useSelector(bapActiveOwnerDuck.selectors.getDuckState);
    const owners = useSelector(ownersDuck.selectors.getOwners);
    const preorderOwnerIds = _get(useSelector(preorderOwnersDuck.selectors.getDuckState), 'ownerIds', []);
    const query = useSelector(queryDuck.selectors.getDuckState);

    const {
        disable_dealer_rating: [isDealerRatingDisabled],
    } = useFeatures([
        'disable_dealer_rating',
    ]);

    const [preorderOwners, setPreorderOwners] = useState([]);

    // build preorder owners in order that they are returned from the custom order end point
    useEffect(() => {
        const preorderOwnersList = [];

        preorderOwnerIds.forEach((id) => {
            if (owners?.[id]) {
                preorderOwnersList.push(owners[id]);
            }
        });

        setPreorderOwners(preorderOwnersList);
    }, [owners, preorderOwnerIds]);

    useEffect(() => {
        dispatch(bapActiveOwnerDuck.creators.setActiveOwner(query?.ownerId || preorderOwnerIds?.[0]));
    }, [query, preorderOwnerIds, dispatch]);

    const handleDealerSelection = (event) => {
        dispatch(bapActiveOwnerDuck.creators.setActiveOwner(event?.target?.value));

    };

    const getOptionValues = (options) => Object.values(options).map((dealerData) => ({
        label: renderOwnerLabel(dealerData, isDealerRatingDisabled),
        value: dealerData?.id,
    }));

    return (preorderOwners?.length > 0) && (
        <Section
            alignment="left"
            className="padding-horizontal-4 padding-vertical-5"
            data-cmp="cntnr-dealers"
            uiContext="section-3"
            heading="Select a Dealer"
            headingClassName="text-blue-darker margin-bottom-3"
            style={{ borderBottom: '1px solid #e1e4e8' }}
        >
            <SeeMore>
                <RadioGroup
                    name="dealers"
                    layout="vertical"
                    value={activeOwnerId}
                    onChange={handleDealerSelection}
                    options={getOptionValues(preorderOwners)}
                />
            </SeeMore>
        </Section>
    );
}

export default React.memo(BuildAndPriceDealerContainer);
